import React from 'react';

const Impressum = () => (
  <div className="max-w-3xl mx-auto bg-white p-10 rounded-2xl shadow-sm border border-slate-100">
    <h1 className="text-3xl font-black text-slate-800 mb-6">Impressum</h1>
    <div className="space-y-6 text-slate-600 leading-relaxed">
      <section>
        <h3 className="font-bold text-slate-800 mb-2">Angaben gemäß § 5 TMG</h3>
        <p>MoBa Inventar App<br />Michael Fayaud<br />Heinz-Lücke-Str. 9A<br />29525 Uelzen</p>
      </section>
      <section>
        <h3 className="font-bold text-slate-800 mb-2">Kontakt</h3>
        <p>Telefon: +49 (175) 654 817 5<br />E-Mail: info@moba-inventar.app</p>
      </section>
      <section>
        <h3 className="font-bold text-slate-800 mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
        <p>Inhaber der Modellbahn-Sammlung</p>
      </section>
      <div className="pt-10 border-t text-xs text-slate-400">
        Diese App dient ausschließlich der privaten Verwaltung einer Modelleisenbahn-Sammlung. Es werden keine kommerziellen Ziele verfolgt.
      </div>
    </div>
  </div>
);

export default Impressum;